import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// About Us page sections

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg-coworking.jpeg";
// import bgImage from "assets/images/Downloads/imagesofrealestate10.jpg";

const content = {
  "dynamic-student-housing": {
    header: "Dynamic Student Housing",
    sections: [
      "AF1985 Inc. Real Estate Solutions: Simplifying Complexity in Real Estate Development",
    ],
  },
  "residential-and-multi-family-communities": {
    header: "Residential and Multi-Family Communities",
    sections: [
      "Our commitment to excellence shines through in the creation of residential and multi-family communities that have been recognized and celebrated for their innovation and quality.",
    ],
  },
  "powerful-public-private-partnerships": {
    header: "Powerful Public-Private Partnerships",
    sections: [
      "We excel in fostering partnerships that bring together the strengths of both sectors to create exceptional developments that benefit the community and stakeholders alike",
    ],
  },
  "premier-corporate-headquarters-and-office-buildings": {
    header: "Premier Corporate Headquarters and Office Buildings",
    sections: [
      "Understanding the significance of workspaces, we deliver thoughtfully designed corporate headquarters and office buildings that inspire productivity and collaboration",
    ],
  },
  "thriving-mixed-use-developments": {
    header: "Thriving Mixed-Use Developments",
    sections: [
      "Our visionary mixed-use developments integrate residential, commercial, and recreational spaces, transforming communities into vibrant hubs of activity.",
    ],
  },
  "efficient-distribution-and-logistic-centers": {
    header: "Efficient Distribution and Logistic Centers",
    sections: [
      "We contribute to the growth of businesses by providing cutting-edge distribution and logistics centers that enhance efficiency and productivity",
    ],
  },
  "enhanced-public-facilities": {
    header: "Enhanced Public Facilities",
    sections: [
      "Our expertise extends beyond the commercial realm, with successful projects including schools, healthcare facilities, and other public amenities that enrich communities.",
    ],
  },
};

function Expertise({ index }) {
  const data = content[index];
  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} />
      </MKBox>
      <Grid container spacing={1} alignItems="stretch">
        <Grid item xs={12} md={6} ml={{ xs: "auto", lg: 6 }} mr={{ xs: "auto", lg: 6 }}>
          <MKBox
            bgColor="white"
            borderRadius="xl"
            shadow="lg"
            display="flex"
            flexDirection="column"
            justifyContent="start"
            mt={{ xs: 20, sm: 18, md: 20 }}
            mb={{ xs: 20, sm: 18, md: 20 }}
            mx={3}
            sx={{ minHeight: "40vh" }}
          >
            <MKBox
              variant="gradient"
              bgColor="info"
              coloredShadow="info"
              borderRadius="lg"
              p={2}
              mx={2}
              mt={-3}
            >
              <MKTypography variant="h3" color="white">
                {data.header}
              </MKTypography>
            </MKBox>
            <MKBox p={3}>
              {data?.sections.map((section) => (
                <MKTypography variant="body2" color="text" mb={3}>
                  {section}
                </MKTypography>
              ))}
            </MKBox>
          </MKBox>
        </Grid>
        <Grid item xs={12} md={5}>
          <MKBox
            display={{ xs: "none", lg: "flex" }}
            width="calc(100% - 1rem)"
            height="calc(100vh - 2rem)"
            borderRadius="lg"
            ml={2}
            mt={2}
            sx={{ backgroundImage: `url(${bgImage})` }}
          />
        </Grid>
      </Grid>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Expertise;
